module.exports = __webpack_public_path__ + "img/img_053@2x.bd999317.png";